import { Link } from "react-router-dom";
import { cn } from "@verse_core/shared_components/ClassName";
import { datadogRum } from "@datadog/browser-rum";
import { useAuth0 } from "@auth0/auth0-react";

interface Props {
  role: string;
}

export const ProviderAccountDropdown = (props: Props) => {
  const { isAuthenticated, logout } = useAuth0();

  return (
    <div
      className={cn(
        `tw-absolute tw-right-0 tw-top-[100%] tw-z-10 tw-mt-[-20px] tw-hidden tw-w-[200px] tw-rounded-md tw-border-[0.5px] tw-border-solid tw-border-gray-5 tw-bg-white tw-shadow-sm group-hover:tw-block`,
      )}
    >
      {props.role === "provider" && (
        <Link
          className="tw-block tw-w-[100%] tw-rounded-md tw-p-[13px] tw-text-black tw-no-underline hover:tw-bg-light-grey"
          to="/provider-settings"
        >
          Account Settings
        </Link>
      )}
      <a
        className="tw-block tw-w-[100%] tw-cursor-pointer tw-rounded-md tw-p-5 tw-text-black tw-no-underline hover:tw-bg-light-grey"
        href={isAuthenticated ? undefined : "/graphql/logout"}
        onClick={() => {
          datadogRum.stopSession();
          if (isAuthenticated) {
            logout({ logoutParams: { returnTo: window.location.origin } });
          }
        }}
      >
        Log out
      </a>
    </div>
  );
};
